/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { BrowserModule, Title } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ThemeModule } from '@theme/theme.module';
import { AppRoutingModule } from './app.routing';
import { HttpClientModule } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy, registerLocaleData } from '@angular/common';
import { PartialsModule } from '@partials/partials.module';
import { TranslateModule } from '@ngx-translate/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule, RouterState } from '@ngrx/router-store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

/*Cookies*/
import { CookieService } from 'ngx-cookie-service';
import { CustomSerializer } from '@core/store/serializer/custom-serializer';
import { EffectsArray } from '@core/store/effects';
import { metaReducers, reducers } from '@core/store';

import localeEs from '@angular/common/locales/es';
import { interceptors } from '@core/security/interceptors/interceptors';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from 'environments/environment';
import { SwUpdateNotifierService } from '@utils/services/sw-update-notifier.service';
import { NgIdleModule } from '@ng-idle/core';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

registerLocaleData(localeEs, 'es');

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		ThemeModule,
		HttpClientModule,
		AppRoutingModule,
		PartialsModule,
		// METRONIC
		TranslateModule.forRoot(),

		// NGRX
		StoreModule.forRoot(reducers, { metaReducers }),
		EffectsModule.forRoot(EffectsArray),
		StoreRouterConnectingModule.forRoot({
			stateKey: 'router',
			routerState: RouterState.Minimal,
			serializer: CustomSerializer,
		}),
		StoreDevtoolsModule.instrument({ connectInZone: true }),
		ServiceWorkerModule.register('ngsw-worker.js', {
			enabled: environment.production || environment.enableServiceWorker,
			registrationStrategy: environment.production
				? 'registerWhenStable:30000' // Producción: espera 30s para estabilidad
				: 'registerWhenStable:5000', // Dev/QA: registro rápido para pruebas
		}),
		NgIdleModule.forRoot(),
		NgIdleKeepaliveModule.forRoot(),
	],
	providers: [
		{
			provide: LocationStrategy,
			useClass: HashLocationStrategy,
		},
		{
			provide: LOCALE_ID,
			useValue: 'es',
		},
		Title,
		CookieService,
		interceptors,
		SwUpdateNotifierService,
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
